export function equalsDeep<T>(a: unknown, b: T): a is T {
  if (a === b) return true;
  if (a && b && typeof a == 'object' && typeof b == 'object') {
    if (a.constructor !== b.constructor) return false;

    let length, i;
    if (Array.isArray(a) && Array.isArray(b)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0; ) if (!equalsDeep(a[i], b[i])) return false;
      return true;
    }

    const aRecord = a as Record<string, unknown>;
    const bRecord = b as Record<string, unknown>;

    if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
    if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();

    const keys = Object.keys(aRecord);
    length = keys.length;
    if (length !== Object.keys(bRecord).length) return false;

    for (i = length; i-- !== 0; ) if (!Object.prototype.hasOwnProperty.call(bRecord, keys[i])) return false;

    for (i = length; i-- !== 0; ) {
      const key = keys[i];
      if (!equalsDeep(aRecord[key], bRecord[key])) return false;
    }

    return true;
  }
  return a !== a && b !== b;
}
